<template>
  <div>
    <b-modal
      v-model="stocksModal.status"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Zenno Stock"
    >
      <b-form-group>
        <b-input-group>
          <b-form-input
            v-model="stocksModal.keywords"
            placeholder="Hamburger, Pizza..."
            @keydown.enter="searchStock"
          />
          <b-input-group-append>
            <b-button @click="searchStock">
              <FeatherIcon icon="SearchIcon" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <hr>
      <b-row>
        <b-col
          v-for="item in dataList"
          :key="item.id"
          cols="12"
          md="4"
        >
          <b-img
            :src="item.image"
            fluid
            rounded
          />
          <b-button
            class="mt-1 mb-1"
            variant="success"
            size="sm"
            block
            :disabled="submitButton"
            @click="setStockImage(item.id)"
          >
            <FeatherIcon icon="CheckCircleIcon" />
            Uygula
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import {
  BModal, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BRow, BCol, BImg,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'StocksModal',
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      submitButton: false,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['zennoStocks/dataList']
    },
    stocksModal() {
      return this.$store.getters['zennoStocks/stocksModal']
    },
  },
  methods: {
    searchStock() {
      this.$store.dispatch('zennoStocks/getDataList', { keywords: this.stocksModal.keywords })
    },
    getDataList() {
      this.$store.commit('products/SET_LOADING', true)
      this.$store.dispatch('productGallery/getDataList', this.$route.params.id)
        .then(res => {
          if (res) {
            this.$store.commit('products/SET_LOADING', false)
          }
        })
    },
    setStockImage(id) {
      this.submitButton = true
      this.$store.dispatch('productGallery/saveData', {
        id_zenno_stocks: id,
        id_products: this.$route.params.id,
      })
        .then(response => {
          if (response.status) {
            this.showToast({
              variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: response.message,
            })
            this.getDataList()
            this.submitButton = false
            this.stocksModal.status = false
          } else {
            this.showToast({
              variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: response.message,
            })
            this.getDataList()
            this.submitButton = false
            this.stocksModal.status = false
          }
        })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
